import React, { useState, useEffect } from 'react';
import { LanguageProvider } from './context/LanguageContext';
import ProfezacLanding from './components/landing/ProfezacLanding';

// Initialize i18n system
import './i18n';

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container mt-5 text-center">
          <h4>Something went wrong</h4>
          <p>Please refresh the page and try again.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [languageProviderReady, setLanguageProviderReady] = useState(false);

  // Check if language provider initializes correctly
  useEffect(() => {
    try {
      localStorage.getItem('test');
      setLanguageProviderReady(true);
    } catch (error) {
      console.error("localStorage not available:", error);
      // Still allow the app to work without localStorage
      setLanguageProviderReady(true);
    }
  }, []);

  if (!languageProviderReady) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <LanguageProvider>
        <div className="App">
          <ProfezacLanding />
        </div>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;